<template>
  <v-dialog scrollable :fullscreen="isFullScreen" persistent v-model="modal" :max-width="maxWidthModal">
    <ModalCredits v-if="openCredits" :literal="literal"></ModalCredits>
    <ModalResource v-if="openResource" :literal="literal" :typeModalResource="typeModalResource"></ModalResource>
    <ModalAddResource v-if="openAddResource" :literal="literal"></ModalAddResource>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";

import ModalCredits from "./ModalCredits";
import ModalResource from "./ModalResource";
import ModalAddResource from "./ModalAddResource";

export default {
  name: "Modal",

  data: () => ({
    // creditos: ""
  }),
  components: {
    ModalCredits,
    ModalResource,
    ModalAddResource
  },
  computed: {
    ...mapState(
      [
        "literal", 
        "modal", 
        "srcResource", 
        "maxWidthModal", 
        "isFullScreen", 
        "typeModalResource",
        "openCredits", 
        "openResourceFull", 
        "openResource",
        "openAddResource"
      ]),
  },
};
</script>